import { useDispatch, useSelector } from 'react-redux';
import lookie from 'lookie';
import defaultAvatarImg from '@/assets/image/default-avatar.png';
import defaultFemaleAvatarImg from '@/assets/image/default-women-avatar.png';
import { selectedCurrentCustomer } from '@/store/customer';
import { setStoreInfo } from '@/store/device';
import { CURRENT_ANDROID_ID } from '@/constant';
import service from '@/service';
import cx from './index.module.scss';

const HeaderMemberInfo = ({
  avatarUrl,
  name,
  handleClick,
  textContent = null,
  gender,
}: {
  avatarUrl?: string;
  name?: string;
  handleClick?: () => void;
  textContent?: string;
  gender?: Customer.Gender;
}) => {
  const currentCustomer = useSelector(selectedCurrentCustomer);
  const username = name ?? currentCustomer?.name;
  const imgUrl = avatarUrl ?? currentCustomer?.avatarUrl;
  const userGender = gender ?? currentCustomer?.gender;
  const dispatch = useDispatch();

  const handleClickWrapper = async () => {
    const androidId = lookie.get(CURRENT_ANDROID_ID);
    try {
      const { data } = await service.system.getBoundStore(androidId);
      dispatch(setStoreInfo(data));
    } finally {
      handleClick && handleClick();
    }
  };

  return (
    <div className={cx('header-member-info')} onClick={handleClickWrapper}>
      <img
        src={imgUrl ? imgUrl : userGender === 'Female' ? defaultFemaleAvatarImg : defaultAvatarImg}
        alt="avatar"
        className={cx('img')}
        onError={e => ((e.target as HTMLImageElement).src = defaultAvatarImg)}
      />

      <span>{username}</span>
      <span style={{ color: 'rgba(0, 0, 0, 0.25)' }}>{textContent ? textContent : '的服务单'}</span>
    </div>
  );
};

export default HeaderMemberInfo;
